import tourConfig from '../common/tour/config';

const tourSteps = (language) => {
	let tourOptions = tourConfig.getOptions(language);
	tourOptions.steps = [
		{
			element: '.container-main-principal',
			intro: language.tour.driverBehaviorTour.upperSector,
			position: 'bottom'
		},
		{
			element: '.help-buttons-tour',
			intro: language.tour.driverBehaviorTour.helpButtons,
			position: 'right'
		},
		{
			element: '.indicator-tour',
			intro: language.tour.driverBehaviorTour.behaviorGrade,
			position: 'right'
		},
		{
			element: '.travel-idicators',
			intro: language.tour.driverBehaviorTour.distributionIcons,
			position: 'right'
		},
		{
			element: '.evolution',
			intro: language.tour.driverBehaviorTour.behaviorGradeEvolution,
			position: 'left'
		},
		{
			element: '.left-col',
			intro: language.tour.driverBehaviorTour.trips,
			position: 'right'
		},
		{
			element: '.right-col',
			intro: language.tour.driverBehaviorTour.mainIndicators,
			position: 'left'
		},
		{
			element: '.excel-buttons',
			intro: language.tour.driverBehaviorTour.excelButton,
			position: 'left'
		}
	];

	return tourOptions;
};

export default tourSteps;


// WEBPACK FOOTER //
// ./source/client/components/driver_behavior/tourSteps.js